import React from "react";
import {Icon} from '../../decor/SarasIcons'

const SarasIconImage = ({className, style, icon})=>{

    const renderIcon = () => {
        let IconImage = Icon[icon];
        
        if(IconImage){
            return(
                <IconImage className={className} style={style} />
            )
        }
    }

    return renderIcon();
}

export default SarasIconImage